import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import { telegram } from '../utils/telegram';

/**
 * Telegram MainButton lifecycle hook.
 * Mounts: sets button text + handler + shows.
 * Unmounts: hides button + removes handler.
 * enabled=false bo'lsa: button ko'rinadi lekin disabled.
 *
 * Ikkita alohida effect:
 * 1. onClick/text o'zgarganda — handlerni qayta register qiladi (hide → show sikli)
 * 2. enabled o'zganganda — faqat enable/disable, HIDE qilmaydi
 */
export function useMainButton(
  text: string,
  onClick: () => void,
  enabled: boolean = true,
): void {
  // Effect 1: handler va text — faqat o'zgarganda ro'yxatdan o'tkazadi
  useEffect(() => {
    telegram.setMainButton(text, onClick);
    WebApp.MainButton[enabled ? 'enable' : 'disable']();
    return () => {
      telegram.hideMainButton();
    };
  // enabled intentionally excluded — Effect 2 handles it without hide/show cycle
  }, [text, onClick]);

  // Effect 2: enabled — tugmani YASHIRMASDAN faqat holat o'zgartiradi
  useEffect(() => {
    if (enabled) {
      WebApp.MainButton.enable();
    } else {
      WebApp.MainButton.disable();
    }
  }, [enabled]);
}
